import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const bottomSheetDefaultVariants = {}
const bottomSheetCompoundVariants = []

const bottomSheetSlotNames = [
  [
    "root",
    "bottomSheet__root"
  ],
  [
    "overlay",
    "bottomSheet__overlay"
  ],
  [
    "content",
    "bottomSheet__content"
  ],
  [
    "handle",
    "bottomSheet__handle"
  ],
  [
    "contentInner",
    "bottomSheet__contentInner"
  ],
  [
    "header",
    "bottomSheet__header"
  ],
  [
    "title",
    "bottomSheet__title"
  ],
  [
    "description",
    "bottomSheet__description"
  ],
  [
    "body",
    "bottomSheet__body"
  ],
  [
    "footer",
    "bottomSheet__footer"
  ],
  [
    "close",
    "bottomSheet__close"
  ]
]
const bottomSheetSlotFns = /* @__PURE__ */ bottomSheetSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, bottomSheetDefaultVariants, getSlotCompoundVariant(bottomSheetCompoundVariants, slotName))])

const bottomSheetFn = memo((props = {}) => {
  return Object.fromEntries(bottomSheetSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const bottomSheetVariantKeys = [
  "contained"
]
const getVariantProps = (variants) => ({ ...bottomSheetDefaultVariants, ...compact(variants) })

export const bottomSheet = /* @__PURE__ */ Object.assign(bottomSheetFn, {
  __recipe__: false,
  __name__: 'bottomSheet',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: bottomSheetVariantKeys,
  variantMap: {
  "contained": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, bottomSheetVariantKeys)
  },
  getVariantProps
})